<template>
  <b-modal id="partial-repay-modal" ref="modal" name="disburse" centered hide-footer hide-header>
    <center><h3><strong>{{ $t('TRANSACTION_INFO') }}</strong></h3></center>
    <center class="input-wrapper">
      <date-input
        :label="$t('TRANSACTION_DATE')"
        v-model="registeredOn"
        borderbottom
        required
        :validate="validateTransactionDate"
        ref="dateInputRef"
      />

      <select-input
        :label="$t('TRANSACTION_TYPE')"
        v-model="type"
        :items="types"
        :placeholder="$t('SELECT_ONE')"
        required
        borderbottom
        ref="typeInputRef"
      />

      <text-input
        :label="$t('AMOUNT')"
        v-model="amount"
        :hint="changeDigitToViText(amount)"
        borderbottom
        required
        ref="amountInputRef"
      />

      <div class="controls">
        <primary-button @click="close" blue :text="$t('BACK')" />
        <primary-button @click="save" :disabled="!type" :text="$t('PARTIAL_REPAY')" />
      </div>
    </center>
  </b-modal>
</template>

<script>
import moment from 'moment';
import { watch, ref, computed } from '@vue/composition-api';

import PrimaryButton from '@/components/PrimaryButton';

import { TRANSACTION_TYPES, DATE_FORMAT, DISPLAY_DATE_FORMAT } from '@/consts';
import { changeDigitToViText } from '@/helpers';

import DateInput from '@/components/DateInput';
import SelectInput from '@/components/SelectInput';
import TextInput from '@/components/TextInput';

export default {
  name: 'PartialRepayDialog',
  components: {
    PrimaryButton,
    SelectInput,
    DateInput,
    TextInput
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disbursedOn: {
      type: String,
      required: true
    },
  },
  setup(props, { root, emit }) {
    const registeredOn = ref(moment().format(DISPLAY_DATE_FORMAT));
    const amount = ref(0);
    const type = ref(TRANSACTION_TYPES.CASH);
    const modal = ref(null);

    const dateInputRef = ref(null);
    const typeInputRef = ref(null);
    const amountInputRef = ref(null);

    const types = Object.keys(TRANSACTION_TYPES).map((key) => ({
      value: key,
      text: root.$t(key)
    }));

    const close = () => {
      emit('input', false);
      type.value = null;
    };

    const save = async () => {
      const inputs = [
        dateInputRef.value,
        typeInputRef.value,
        amountInputRef.value
      ];

      let valid = true;

      inputs.forEach((input) => {
        const v = input.validateInput();
        valid = valid && v;
      });

      if (!valid) return;

      emit('repay', {
        registeredOn: moment(registeredOn.value, DISPLAY_DATE_FORMAT).format(DATE_FORMAT),
        type: type.value,
        amount: Math.round(Math.round(parseFloat(amount.value) * 1000) * 1000)
      });
    };

    const validateTransactionDate = (val) => {
      const date = moment(val, DISPLAY_DATE_FORMAT, true).startOf('day');

      if (date.isValid()) {
        const disbursementDate = moment(props.disbursedOn, DATE_FORMAT).startOf('day');
        const today = moment().startOf('day');

        if (
          (disbursementDate > date)
          || (today < date)
        ) {
          return 'INVALID_TRANSACTION_DATE';
        }

        return '';
      }

      return 'INVALID_DATE_FORMAT';
    };

    const popup = computed(() => props.value);
    watch(popup, (value) => {
      if (value) {
        modal.value.show();
      } else {
        modal.value.hide();
      }
    });

    return {
      modal,
      type,
      types,
      close,
      save,
      registeredOn,
      amount,
      dateInputRef,
      typeInputRef,
      amountInputRef,
      validateTransactionDate,
      changeDigitToViText
    };
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

#partial-repay-modal {
  .modal-body {
    padding: 30px 15px;
  }

  h3 {
    margin-bottom: 20px;
  }

  .input-wrapper {
    > .input {
      width: 300px;
      text-align: left;
      margin-bottom: 20px;
    }
  }

  .controls {
    margin-top: 20px;

    .primary-button {
      margin-left: 15px;
      border-radius: 4px;
    }
  }
}
</style>
